// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HGZPOsZEskeH4LamHYK_R {\n   table-layout: fixed;\n}", "",{"version":3,"sources":["webpack://./src/web/form/CommonNotificationSummary.css"],"names":[],"mappings":"AAAA;GACG,mBAAmB;AACtB","sourcesContent":[":local(.fixedTable) {\n   table-layout: fixed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fixedTable": "HGZPOsZEskeH4LamHYK_R"
};
export default ___CSS_LOADER_EXPORT___;
